import { esc } from '@sunday/util';
/**
 * Help centre: three small tools. Words come from the page (section settings); nothing is typed here.
 *   <sunday-help-search>  filters the help articles by title or topic as you type
 *   <sunday-help-vote>    "Did this answer your question?": sends an analytics event; No shows WhatsApp and Call
 *   .sd-hvid buttons      a video still that loads YouTube only when tapped
 *   "Label: …" notes      a body paragraph opening with a bold label gets class sd-hnote
 */

class SundayHelpSearch extends HTMLElement {
  connectedCallback() {
    this.cfg = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.input = this.querySelector('input');
    this.out = this.querySelector('[data-res]');
    this.input.addEventListener('input', () => this.show());
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const a = this.out.querySelector('a');
        if (a) a.click();
      }
    });
  }

  show() {
    const q = this.input.value.trim().toLowerCase();
    if (!q) {
      this.out.hidden = true;
      this.out.innerHTML = '';
      return;
    }
    const words = q.split(/\s+/);
    const hits = this.cfg.items.filter(([t, , g]) => {
      const hay = `${t} ${g || ''}`.toLowerCase();
      return words.every((w) => hay.includes(w));
    });
    const n = hits.length === 1 ? this.cfg.one : String(this.cfg.many).replace('{n}', hits.length);
    this.out.hidden = false;
    if (!hits.length) {
      this.out.innerHTML = `<p>${esc(this.cfg.none)} ${this.cfg.wa ? `<a class="sd-more" href="${esc(this.cfg.wa)}" target="_blank" rel="noopener">${esc(this.cfg.waLabel)}</a>` : ''}</p>`;
      return;
    }
    this.out.innerHTML = `<p>${esc(n)}</p><ul class="sd-hlist">${hits.map(([t, u]) => `<li><a href="${esc(u)}"><span>${esc(t)}</span></a></li>`).join('')}</ul>`;
  }
}

class SundayHelpVote extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-v]');
      if (!b) return;
      const v = b.dataset.v;
      try {
        window.Shopify?.analytics?.publish?.('sunday_help_vote', { article: this.dataset.article, answer: v });
      } catch (_) { /* analytics is optional */ }
      this.querySelector('[data-ask]').hidden = true;
      this.querySelector(v === 'yes' ? '[data-yes]' : '[data-no]').hidden = false;
    });
  }
}

// A paragraph that opens with a bold "Label:" and goes on is a note (e.g. "Important: …"): drawn as a soft box.
for (const p of document.querySelectorAll('.sd-hbody > p')) {
  const b = p.firstElementChild;
  if (b && p.firstChild === b && /^(STRONG|B)$/.test(b.tagName) && /:\s*$/.test(b.textContent) && p.textContent.trim().length > b.textContent.trim().length + 3) p.classList.add('sd-hnote');
}

document.addEventListener('click', (e) => {
  const b = e.target.closest('.sd-hvid[data-vid]');
  if (!b) return;
  const f = document.createElement('iframe');
  f.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(b.dataset.vid)}?autoplay=1&rel=0`;
  f.title = b.getAttribute('aria-label') || '';
  f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
  f.allowFullscreen = true;
  const w = document.createElement('div');
  w.className = 'sd-hvid';
  w.append(f);
  b.replaceWith(w);
});

if (!customElements.get('sunday-help-search')) customElements.define('sunday-help-search', SundayHelpSearch);
if (!customElements.get('sunday-help-vote')) customElements.define('sunday-help-vote', SundayHelpVote);
